import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PACIFIC_STARTER_FEED_ITEMS = createFcmConfig('pacific_starter_feed_items', {
	normalizer: createJsonNormalizer(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'array',
				shape: {
					type: 'string',
				},
			},
		}),
	),
	defaultValue: [] as readonly string[][],
});
